import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { Typography, SvgIcon } from "@material-ui/core";
import CheckCircleOutline from "@material-ui/icons/CheckCircleOutline";
import { FormattedMessage } from "react-intl";
import { styles } from "./constants/styles";
import messages from "./constants/messages";
import Footer from "../../../../../layouts/Footer";
import Layout from "../../../../../layouts/Layout";
import Header from "../../../../../layouts/Header";
type Props = WithStyles<typeof styles>;

const ExpiredPasswordLinkPage: React.FC<Props> = (props: Props) => {
  const { classes } = props;
  
  return (
    <Layout>
      <Header />
      <div className={classes.root}>
        <SvgIcon fontSize={"large"} color={"primary"}>
          <CheckCircleOutline />
        </SvgIcon>
        <Typography className={classes.header}>
          <FormattedMessage {...messages.checkMail} />
        </Typography>
      </div>
      <Footer />
    </Layout>
  );
};

export default withStyles(styles)(ExpiredPasswordLinkPage);